var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-by-tabs"},[_c('VuetifyToolBar',{attrs:{"hide-back-button":true,"title":"Mi cuenta"}}),_c('v-container',[_c('VuetifyTabs',{attrs:{"items":_vm.currentItems}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }